// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__fbdQg","range":"MonthRangeSwitch_range__32iw1","disabled":"MonthRangeSwitch_disabled__JVQMy"};